module.exports = __webpack_public_path__ + "img/Autocolant VVE-01.28e5d460.jpg";